module.exports = __webpack_public_path__ + "img/image (20).bef0e741.webp";